class SavingsPlanner {
    constructor(calculatormain) {
      this.calculatormain = document.getElementById(calculatormain);
      this.currencyTitle = "AED"
      this.profitRateYes = 3.75;
      this.profitRateNo = 3.75;
      
      this.savingPlannerRadio;
      this.init();
    }
  
    init() {
      if (this.calculatormain) {
        this.currencyTitle = this.calculatormain.getAttribute("data-currencytitle");
        this.profitRateYes = this.calculatormain.getAttribute("data-profityes");
        this.profitRateNo = this.calculatormain.getAttribute("data-profitno");
        this.setupJQueryPlugins();
        this.savingPlannerRadio = this.calculatormain.querySelectorAll(
          "input[name='options-savings-planner']"
        );
        this.savingPlannerRadio.forEach((item) => {
          item.addEventListener("change", this.radioChange.bind(this, item));
        });
        let savingsButtonClick =
          this.calculatormain.querySelector("#btnClaculat");
        savingsButtonClick.addEventListener("click", () =>
          this.btnCalculateSavings()
        );
      }
    }
  
    setupJQueryPlugins() {
      let checkLang = document.querySelector("html").getAttribute('lang');
      let sliderMax = parseInt(
        $(this.calculatormain).find("#monthly-payment").attr("data-slider-max")
      );
      let sliderMin = parseInt(
        $(this.calculatormain).find("#monthly-payment").attr("data-slider-min")
      );
      let step = parseInt(
        $(this.calculatormain).find("#monthly-payment").attr("data-slider-step")
      );
      let value = parseInt(
        $(this.calculatormain)
          .find("#input-monthly-payment")
          .attr("data-slider-initialvalue")
      );
  
      var pathname = window.location.pathname;
      $(".clsResult").hide();
      // jquery-ui slider
      $("#monthly-payment").slider({
        range: "min",
        value: value,
        min: sliderMin,
        max: sliderMax,
        step: step,
        isRTL: checkLang === 'ar' ? true : false,
        slide: function (event, ui) {
          $("#input-monthly-payment").val(ui.value);
        },
      });
  
      let sliderMaxTenure = parseInt(
        $(this.calculatormain).find("#tenure").attr("data-slider-max")
      );
      let sliderMinTenure = parseInt(
        $(this.calculatormain).find("#tenure").attr("data-slider-min")
      );
      let stepTenure = parseInt(
        $(this.calculatormain).find("#tenure").attr("data-slider-step")
      );
      let valueTenure = parseInt(
        $(this.calculatormain)
          .find("#input-tenure")
          .attr("data-slider-initialvalue")
      );
  
      $("#tenure").slider({
        range: "min",
        value: valueTenure,
        min: sliderMinTenure,
        max: sliderMaxTenure,
        step: stepTenure,
        isRTL: checkLang === 'ar' ? true : false,
        slide: function (event, ui) {
          $("#input-tenure").val(ui.value);
        },
      });
  
      let sliderMaxGrowth = parseInt(
        $(this.calculatormain).find("#growth-rate").attr("data-slider-max")
      );
      let sliderMinGrowth = parseInt(
        $(this.calculatormain).find("#growth-rate").attr("data-slider-min")
      );
      let stepGrowth = parseInt(
        $(this.calculatormain).find("#growth-rate").attr("data-slider-step")
      );
      let valueGrowth = parseInt(
        $(this.calculatormain)
          .find("#input-growth-rate")
          .attr("data-slider-initialvalue")
      );
  
      $("#growth-rate").slider({
        range: "min",
        value: valueGrowth,
        min: sliderMinGrowth,
        max: sliderMaxGrowth,
        step: stepGrowth,
        isRTL: checkLang === 'ar' ? true : false,
        slide: function (event, ui) {
          $("#input-growth-rate").val(ui.value);
        },
      });
  
      let sliderMaxSaving = parseInt(
        $(this.calculatormain).find("#savings-target").attr("data-slider-max")
      );
      let sliderMinSaving = parseInt(
        $(this.calculatormain).find("#savings-target").attr("data-slider-min")
      );
      let stepSaving = parseInt(
        $(this.calculatormain).find("#savings-target").attr("data-slider-step")
      );
      let valueSaving = parseInt(
        $(this.calculatormain)
          .find("#input-savings-target")
          .attr("data-slider-initialvalue")
      );
  
      $("#savings-target").slider({
        range: "min",
        value: valueSaving,
        min: sliderMinSaving,
        max: sliderMaxSaving,
        step: stepSaving,
        isRTL: checkLang === 'ar' ? true : false,
        slide: function (event, ui) {
          $("#input-savings-target").val(ui.value);
        },
      });
  
      $("#idSavingsTarget").hide();
      this.clearFields();
    }
  
    clearFields() {
      $('[id$="input-growth-rate"]')?.text(this.profitRateYes + "%");
      $('[id$="total_finance_amount"]')?.text(this.currencyTitle + "0");
      $('[id$="monthly_installment"]')?.text(this.currencyTitle + "0");
  
      $("#radio-salary-transfer-yes")?.prop("checked", true);
      $("#radio-salary-transfer-no")?.prop("checked", false);
  
      $("#property_value")?.val("");
  
      // jquery-ui slider
      $("#percent_finance")?.slider({
        range: "min",
        value: 0,
        min: 0,
        max: 85,
        step: 1,
        isRTL: true,
        slide: function (event, ui) {
          $("#percent_finance_input").val(ui.value);
        },
      });
      $("#property_value")?.val("0");
      $("#percent_finance_input")?.val("0");
      $("#tenure_input")?.val("0");
    }
  
    numberOnly(id) {
      const element = document.getElementById(id);
      element.value = element.value.replace(/[^0-9]/g, "");
    }
  
    btnCalculateSavings() {
      CalculateSavings();
      if ($(".radio-savings-planner input:radio:checked").val() == "savings-target") {
        $("#labeltotalSavings").hide();
         $("#labelyouhavetoSave").show();
      }
      else{
        $("#labeltotalSavings").show();
         $("#labelyouhavetoSave").hide();
      }
    }

  
    radioChange(target, event) {
      if (target.value == "monthly-payment") {
        $("#idSavingsTarget").hide();
        $("#idMontlyPayment").show();
        $("#lbMontlySavings").show();
        $(".ClsSavingMonthly").show();
        $("#lbyouhavetoSave").hide();
      } else {
        $("#lbMontlySavings").hide();
        $(".ClsSavingMonthly").hide();
        $("#idSavingsTarget").show();
        $("#idMontlyPayment").hide();
        $("#lbyouhavetoSave").show();
      }
    }
  }
  
  export default SavingsPlanner;
  